import { MdsItemListSize } from "@/design-system/components/item-list/types";
import { MdsItemListOtherRowData } from "@/design-system/components/item-list/types/MdsItemListRowTypes";
import styled from "@emotion/styled";

/**
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const MdsItemListOtherRow = ({ data }: { data: MdsItemListOtherRowData }) => {
  const { size = MdsItemListSize.Medium } = data;

  return <Wrapper $size={size}>{data.payload.children}</Wrapper>;
};

const Wrapper = styled.div<{ $size: MdsItemListSize }>`
  ${({ $size }) => rowSizeStyleMapping[$size]};
`;

const rowSizeStyleMapping: { [key in MdsItemListSize]: string } = {
  [MdsItemListSize.Medium]: `height: 48px; line-height: 48px;`,
  [MdsItemListSize.Large]: `height: 56px; line-height: 56px;`,
  [MdsItemListSize.XLarge]: `min-height: 60px; line-height: 60px;`,
  [MdsItemListSize.Full]: `height: 100%;`,
};
